import React, { useEffect, useState } from "react";
import { renderRoutes } from "react-router-config"
import { observer } from "mobx-react";
import { useStores } from "../hooks";
import { Redirect } from "react-router-dom";
import useQuery from "../hooks/useQuery";


const SecurityLayout = (props: any) => {
    const [isReady, setIsReady] = useState(false);
    const { authStore, generalStore } = useStores();

    const { authToken } = useQuery<{ authToken?: string }>();


    useEffect(() => {
        if(authToken) {
            authStore.loginAsUser(authToken);
        }
        authStore.getCurrentUser().then(() => {
            setIsReady(true);
            const locale =  authStore.organizationBranch?
                authStore.organizationBranch.data.defaultLocaleId:
                "ru";
            generalStore.setLocale({
                id: locale
            });
        })
    }, []);



    if (!isReady) return null;

    //@ts-ignore
    const route = props.route || {};
    const { isAuthorized } = authStore;
    if (isAuthorized) {
        if( window.location.hash === '#'
            || window.location.hash === '#/'
            || window.location.pathname === "/" ){
            return <Redirect to={"/menus/regular/list"}/>
        }
        return renderRoutes(route.routes);
    } else {
        return <Redirect to={"/auth/sign-in"}/>
    }
};


export default observer(SecurityLayout);
